import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthenticationCheckService } from './authentication-check.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private auth: AuthenticationCheckService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const authToken = this.auth.isAuthenticated();

    if (authToken === true) {
      localStorage.setItem('login', 'true');
    }
    if (authToken === false) {
      localStorage.setItem('login', 'false');
    }

    if (authToken) {
      return true;
    } else {
      this.router.navigateByUrl('/signin', { replaceUrl: true });
      return false;
    }
  }
}
